import React from "react";
import classnames from "classnames";

import "./index.scss";

interface TitleProps {
  title: string;
  fontSize?: string;
  className?: string;
}

const Title = (props: TitleProps) => {
  const { title, className, fontSize = "22px" } = props;

  return (
    <div className={classnames("title", className)} style={{ fontSize }}>
      {title}
    </div>
  );
};

export default Title;
